import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=965816a4&"
import script from "./DashboardPage.vue?vue&type=script&lang=js&"
export * from "./DashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports